import React from 'react';

function Settings() {

  return (
    <p>Hello world!</p>
  );
}

export default Settings;